import {
  createEntityAdapter,
  createSelector,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit'
import { State } from '../../types/StateType'
import { PatientRecordedEcgArrhythmiaWindowEntityType } from './types'

const recordedEcgArrhythmiaWindowAdapter =
  createEntityAdapter<PatientRecordedEcgArrhythmiaWindowEntityType>({
    selectId: (record) => record.key,
  })

let definedProps: { error: any; loading: boolean; success: any } = {
  error: null,
  loading: false,
  success: null,
}

export type getRecordedEcgArrhythmiaWindowActionType = {
  patientKey: string
  startTime: number
  endTime: number
}

const initialState = recordedEcgArrhythmiaWindowAdapter.getInitialState(definedProps)

const recordedEcgArrhythmiaWindowSlice = createSlice({
  name: 'recordedEcgArrhythmiaWindow',
  initialState: initialState,
  reducers: {
    getPatientRecordedEcgArrhythmiaWindow: (
      state,
      action: PayloadAction<getRecordedEcgArrhythmiaWindowActionType>
    ) => {
      state.loading = true
    },
    addPatientRecordedEcgArrhythmiaWindow: (
      state,
      action: PayloadAction<PatientRecordedEcgArrhythmiaWindowEntityType>
    ) => {
      state.loading = false
      recordedEcgArrhythmiaWindowAdapter.removeOne(state, action.payload.key)
      recordedEcgArrhythmiaWindowAdapter.addOne(state, action.payload)
    },
    errorPatientRecordedEcgArrhythmiaWindow: (
      state,
      action: PayloadAction<string | null>
    ) => {
      state.error = action.payload
    },
  },
})

export const {
  addPatientRecordedEcgArrhythmiaWindow,
  errorPatientRecordedEcgArrhythmiaWindow,
  getPatientRecordedEcgArrhythmiaWindow,
} = recordedEcgArrhythmiaWindowSlice.actions

export default recordedEcgArrhythmiaWindowSlice.reducer

const { selectById } = recordedEcgArrhythmiaWindowAdapter.getSelectors()

export const selectPatientRecordedEcgArrhythmiaWindowByKey = (key: string) =>
  createSelector(
    (state: State) => state.patientRecordedEcgArrhythmiaWindowState,
    (patientRecordedEcgArrhythmiaWindow) => selectById(patientRecordedEcgArrhythmiaWindow, key)
  )
